export default function ModelBadge( {modelKey} ) {
    const HINT = {
        novapro: "~$0.015 / 1K tokens (input), ~$0.06 / 1K tokens (output)",
        claude3sonnet:  "~$0.008 / 1K tokens (input), ~$0.024 / 1K tokens (output)",
        titan:   "~lower cost, good for FAQs",
    };

    console.log("ModelKey : " + modelKey);
    const label = (modelKey || "novapro").toLowerCase();

    return (
        <span className="text-xs px-2 py-1 rounded bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200">
            {label} - {HINT[label] || "LLM"}
        </span>
    );
}